var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('pre',{class:`id ${_vm.copiedID ? 'copied' : ''}`,on:{"click":function($event){return _vm.copyID(_vm.id)}}},[_vm._v("# "+_vm._s(_vm.id))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }